import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/material/list'
    return request.post(url,data)
}
export function findAll() {
    return request({
        url: '/shop/findAll',
        method: 'get',
    })
}
export function all() {
    let url = '/material/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/material/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/material/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/material/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/material/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/material/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/material/dmz/options'
    return request.get(url)
}
